// extracted by mini-css-extract-plugin
export var badgeImg = "style-mod--badge-img--195b6";
export var cartBtn = "style-mod--cart-btn--60dfa";
export var cartButton = "style-mod--cart-button--1c479";
export var fadeIn = "style-mod--fadeIn--a232e";
export var stickyInfo = "style-mod--sticky-info--84dd8";
export var stickyInfoContainer = "style-mod--sticky-info-container--62fd3";
export var sumContainer = "style-mod--sum-container--557a1";
export var sumPrices = "style-mod--sum-prices--bb0eb";
export var textPrice = "style-mod--text-price--bab65";